import type { DetailSectionFieldsProps } from "./types-detail-section-fields";
import { DetailSectionFieldsView } from "./view-detail-section-fields";

export function DetailSectionFields(props: DetailSectionFieldsProps) {
  return <DetailSectionFieldsView {...props} />;
}

export type * from "./types-detail-section-fields";
